import './_range-slider-module.js'

/* global rSlider */
rangeSlide()
function rangeSlide() {
  const item = document.getElementById('rangeSlide')
  if (!item) {
    return
  }
  const pointList = item.dataset.point.split(',') // ,区切りで配列に変換
  const setList = item.dataset.set.split(',') // ,区切りで配列に変換

  const inputStart = document.getElementById('rangeSlide-start')
  const inputEnd = document.getElementById('rangeSlide-end')

  const slider = new rSlider({
    target: item,
    values: pointList,
    range: true,
    tooltip: true,
    scale: false,
    labels: false,
    set: setList,
    onChange: function (values) {
      const valueList = values.split(',') // ,区切りで配列に変換
      inputStart.value = valueFix(valueList[0])
      inputEnd.value = valueFix(valueList[1])
    },
  })

  function valueFix(value) {
    if (value === '上限なし') {
      return 'unlimited'
    }
    if (~value.indexOf('\\')) {
      return value.replace(/\\/g, '')
    }
    return value
  }
}
